import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { ReactComponent as IcnWeb1Svg } from 'assets/svgs/icn_web_1.svg' 
import { ReactComponent as IcnWeb2Svg } from 'assets/svgs/icn_web_2.svg' 
import { ReactComponent as IcnWeb3Svg } from 'assets/svgs/icn_web_3.svg'
import { useSystemInfo } from "hooks/useSystemProvider"

type Props = {
    type: string;
}

const IcnWebCardCom = ({type} : Props) => {
    const { isMobile } = useSystemInfo()

    const openLink = () => {
        let tempLink = ''
        switch(type) {
            case 'web':
                tempLink = 'https://dapp.chainge.finance'
                break
            case 'appstore':
                tempLink = 'https://apps.apple.com/us/app/chainge-finance/id1578987516'
                break
            default:
                tempLink = 'https://play.google.com/store/apps/details?id=com.fusion.chainge.android&hl=en_US&gl=US'
        }
        window.open(tempLink, '_blank')
    }

    return <IcnWebCardWrap onClick={openLink}>
        {
            type === 'web' ? <IcnWeb1SvgWrap></IcnWeb1SvgWrap> :
            type === 'appstore' ? <IcnWeb2SvgWrap></IcnWeb2SvgWrap> :
            <IcnWeb3SvgWrap></IcnWeb3SvgWrap>
        }
        <RightWrap>
            <StyledContainer roobertMedium fontSize="10px" lineHeight="13px">
                {
                    type === 'web' ? 'Launch the' :
                    type === 'appstore' ? 'Download on the' : 'Get it on'
                }
            </StyledContainer>
            <StyledContainer roobertSemiBold fontSize={isMobile ? '14px': '16px'} lineHeight="20px">
                {
                    type === 'web' ? 'Web App' :
                    type === 'appstore' ? 'App Store' : 'Google Play'
                }
            </StyledContainer>
        </RightWrap>
    </IcnWebCardWrap>
}

const IcnWebCardWrap = styled(StyledContainer)`
    padding: 5px 11px;
    border-radius: 4px;
    border: solid 1px #b5b7ba;
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    &:hover {
        background: #fff;
        border-color: #e24de5;
    }
`

const RightWrap = styled(StyledContainer)`
    display: flex;
    flex-direction: column;
`

const svgStyle = () => {
    return css`
        width: 20px;
        height: 20px;
        margin-right: 10px;

        @media (max-width: 700px) {
            width: 17px;
            height: 17px;
            margin-right: 7px;
        }
    `
}

const IcnWeb1SvgWrap = styled(IcnWeb1Svg)`
    ${() => svgStyle()}
`

const IcnWeb2SvgWrap = styled(IcnWeb2Svg)`
    ${() => svgStyle()}
`

const IcnWeb3SvgWrap = styled(IcnWeb3Svg)`
    ${() => svgStyle()}
`

export default IcnWebCardCom